__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@debezium/ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@debezium/ui-models", "1.0.0", () => (__webpack_require__.e(464).then(() => (() => (__webpack_require__(77464))))));
			register("@debezium/ui-services", "1.0.0", () => (Promise.all([__webpack_require__.e(635), __webpack_require__.e(644), __webpack_require__.e(300), __webpack_require__.e(425)]).then(() => (() => (__webpack_require__(49425))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(820)]).then(() => (() => (__webpack_require__(28316))))));
			register("react-i18next", "11.18.5", () => (Promise.all([__webpack_require__.e(820), __webpack_require__.e(566)]).then(() => (() => (__webpack_require__(77566))))));
			register("react-router-dom", "5.3.0", () => (Promise.all([__webpack_require__.e(719), __webpack_require__.e(820), __webpack_require__.e(752)]).then(() => (() => (__webpack_require__(69719))))));
			register("react", "17.0.2", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(2784))))));
			register("tslib", "2.4.0", () => (__webpack_require__.e(163).then(() => (() => (__webpack_require__(5163))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};